import React, { useState,useEffect } from 'react';
import { BookOpen, Clock, ChevronRight, Home, Award, Menu, X, Search, Globe, ChevronDown } from 'lucide-react';
import LoadingScreen from './loadingscreen'
import custom_api_func from "./axios_api_func";
import {getCookie,getCsrfToken} from './get_csrfToken'
import senteventdata from './sentdata_sg_analytics'
import { googleconfig } from './config'
import { useNavigate } from 'react-router-dom'
import {jwtDecode} from "jwt-decode";
import { useMsal } from "@azure/msal-react"
import toast, { Toaster } from 'react-hot-toast'

const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600;9..144,700&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

  .sg-page, .sg-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .sg-page {
    --bg: #f7f7fa;
    --bg-alt: #eef0f4;
    --surface: #ffffff;
    --surface-2: #f1f2f6;
    --border: rgba(10,10,20,0.08);
    --border-strong: rgba(10,10,20,0.16);
    --text-primary: #131318;
    --text-secondary: #5c5d70;
    --text-tertiary: #9a9bab;
    --violet: #7c3aed;
    --violet-light: #8b5cf6;
    --blue: #2563eb;
    --green: #059669;
    --amber: #d97706;
    --red: #e11d48;
    --font-display: 'Fraunces', serif;
    --font-body: 'Plus Jakarta Sans', sans-serif;
    --font-mono: 'Plus Jakarta Sans', monospace;
    --shadow-sm: 0 1px 2px rgba(10,10,20,0.04);
    --shadow-lg: 0 20px 40px rgba(10,10,20,0.08);
    font-family: var(--font-body);
    color: var(--text-primary);
    overflow-x: hidden;
  }

  .sg-page a { color: inherit; }
  .sg-page button { font-family: var(--font-body); }
  .sg-page :focus-visible { outline: 2px solid var(--violet); outline-offset: 2px; border-radius: 4px; }

  .sg-page .page { min-height: 100vh; background: var(--bg); width: 100%; }
  .sg-page .page-gray { min-height: 100vh; background: var(--bg-alt); width: 100%; }

  /* ---------- Nav ---------- */
  .sg-page .nav-bar { border-bottom: 1px solid var(--border); padding: 16px 24px; background: var(--surface); }
  .sg-page .nav-content { max-width: 1280px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px; }
  .sg-page .nav-left { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
  .sg-page .logo { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
  .sg-page .logo-mark { width: clamp(32px, 7vw, 40px); height: clamp(32px, 7vw, 40px); border-radius: 10px; background: linear-gradient(135deg, var(--violet), var(--blue)); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .sg-page .logo-img { width: clamp(35px, 8vw, 50px); height: clamp(35px, 8vw, 50px); border-radius: 10px; }
  .sg-page .logo-text { font-family: var(--font-display); font-size: clamp(16px, 4vw, 20px); font-weight: 700; letter-spacing: -0.01em; }
  .sg-page .logo-primary { color: var(--text-primary); }
  .sg-page .logo-suffix { color: var(--text-tertiary); font-weight: 500; font-size: clamp(13px, 3.5vw, 15px); margin-left: 2px; }

  .sg-page .nav-links { display: flex; align-items: center; gap: 24px; }
  .sg-page .nav-link { display: flex; align-items: center; gap: 4px; color: var(--text-secondary); background: none; border: none; cursor: pointer; font-weight: 500; font-size: 15px; }
  .sg-page .nav-link:hover { color: var(--text-primary); }

  .sg-page .btn-outline { padding: 9px 18px; color: var(--violet); border: 1px solid var(--border-strong); border-radius: 8px; background: var(--surface); cursor: pointer; font-weight: 600; font-size: 14px; transition: border-color .15s, background .15s; }
  .sg-page .btn-outline:hover { background: rgba(124,58,237,0.06); border-color: var(--violet); }

  .sg-page .btn-primary {
    padding: 10px 18px; color: #fff; border: none; border-radius: 25px; cursor: pointer;
    font-weight: 600; font-size: 14px; background: linear-gradient(135deg, var(--violet), var(--blue));
    box-shadow: var(--shadow-sm); transition: transform .15s, box-shadow .15s;
  }
  .sg-page .btn-primary:hover { transform: translateY(-1px); box-shadow: var(--shadow-lg); }

  .sg-page .btn-primary-lg {
    padding: 15px 28px; color: #fff; border: none; border-radius: 25px; cursor: pointer;
    font-weight: 600; font-size: clamp(15px, 3vw, 17px); width: 100%; max-width: 320px;
    background: linear-gradient(135deg, var(--violet), var(--blue)); box-shadow: var(--shadow-sm);
    transition: transform .15s, box-shadow .15s;
  }
  .sg-page .btn-primary-lg:hover { transform: translateY(-1px); box-shadow: var(--shadow-lg); }

  /* ---------- Hero ---------- */
  .sg-page .hero { background: var(--bg); position: relative; }
  .sg-page .hero-content { max-width: 1280px; margin: 0 auto; padding: clamp(40px, 8vw, 88px) 24px clamp(32px, 6vw, 56px); }
  .sg-page .hero-grid { display: grid; grid-template-columns: 1fr; gap: 48px; align-items: center; }

  .sg-page .badges { display: flex; gap: 8px; margin-bottom: 20px; flex-wrap: wrap; }
  .sg-page .badge {
    padding: 6px 14px; background: rgba(124,58,237,0.08); color: var(--violet); border: 1px solid transparent;
    border-radius: 9999px; font-size: clamp(12px, 2.5vw, 13px); font-weight: 600; font-family: var(--font-mono); letter-spacing: 0.01em;
  }

  .sg-page .hero-title { font-family: var(--font-display); font-size: clamp(32px, 6vw, 52px); font-weight: 700; color: var(--text-primary); margin-bottom: 8px; line-height: 1.12; letter-spacing: -0.02em; }
  .sg-page .hero-title-line2 { display: block; background: linear-gradient(135deg, var(--violet), var(--blue)); -webkit-background-clip: text; background-clip: text; color: transparent; }
  .sg-page .hero-text { font-size: clamp(16px, 3vw, 18px); color: var(--text-secondary); margin: 16px 0 28px; line-height: 1.65; max-width: 46ch; }

  .sg-page .hero-trust-row { display: flex; flex-wrap: wrap; gap: 20px; margin-top: 28px; }
  .sg-page .hero-trust-item { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--text-tertiary); }
  .sg-page .hero-trust-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--green); flex-shrink: 0; }

  .sg-page .hero-visual { border-radius: 16px; padding: 0; width: 100%; display: flex; align-items: center; justify-content: center; }

  /* ---------- Signature element: certification stack ---------- */
  .sg-page .sg-stack { position: relative; width: 100%; max-width: 420px; padding: 24px 0 8px; }
  .sg-page .sg-card {
    background: var(--surface); border: 1px solid var(--border); border-radius: 14px;
    box-shadow: var(--shadow-lg); animation: sg-rise .6s ease both;
  }
  .sg-page .sg-card-main { padding: 22px; position: relative; z-index: 3; animation-delay: .05s; }
  .sg-page .sg-card-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }
  .sg-page .sg-card-label { font-family: var(--font-mono); font-size: 11px; letter-spacing: 0.04em; text-transform: uppercase; color: var(--text-tertiary); }
  .sg-page .sg-live-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--green); box-shadow: 0 0 0 4px rgba(5,150,105,0.14); animation: sg-pulse 2s ease-in-out infinite; }

  .sg-page .sg-ring-wrap { position: relative; width: 128px; height: 128px; margin: 0 auto 16px; }
  .sg-page .sg-ring { width: 128px; height: 128px; transform: rotate(-90deg); }
  .sg-page .sg-ring-track { fill: none; stroke: var(--surface-2); stroke-width: 10; }
  .sg-page .sg-ring-fill {
    fill: none; stroke: url(#sgRingGradient); stroke-width: 10; stroke-linecap: round;
    stroke-dasharray: 327; stroke-dashoffset: 327; animation: sg-ring-draw 1.4s ease .3s forwards, sg-ring-glow 3s ease-in-out 1.7s infinite;
  }
  .sg-page .sg-ring-value { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; }
  .sg-page .sg-ring-number { font-family: var(--font-mono); font-size: 26px; font-weight: 500; color: var(--text-primary); }
  .sg-page .sg-ring-caption { font-size: 11px; color: var(--text-tertiary); margin-top: 2px; }
  .sg-page .sg-card-footer { text-align: center; font-size: 13px; color: var(--text-secondary); font-weight: 500; }

  .sg-page .sg-card-feed {
    padding: 16px 18px; position: absolute; top: -18px; right: -34px; width: 220px; z-index: 2;
    animation-delay: .2s;
  }
  .sg-page .sg-feed { list-style: none; margin-top: 10px; display: flex; flex-direction: column; gap: 10px; }
  .sg-page .sg-feed-row { display: flex; align-items: center; gap: 8px; font-size: 12px; opacity: 0; animation: sg-fade-in .5s ease forwards; }
  .sg-page .sg-feed-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
  .sg-page .sg-dot-green { background: var(--green); }
  .sg-page .sg-dot-amber { background: var(--amber); }
  .sg-page .sg-feed-name { flex: 1; color: var(--text-secondary); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .sg-page .sg-feed-value { font-family: var(--font-mono); font-weight: 500; color: var(--text-primary); }

  .sg-page .sg-card-streak {
    padding: 14px 18px; position: absolute; bottom: -22px; left: -28px; width: 168px; z-index: 1;
    display: flex; flex-direction: column; gap: 4px; animation-delay: .35s;
  }
  .sg-page .sg-streak-number { font-family: var(--font-mono); font-size: 20px; font-weight: 500; color: var(--amber); }

  @keyframes sg-rise { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes sg-fade-in { from { opacity: 0; transform: translateX(6px); } to { opacity: 1; transform: translateX(0); } }
  @keyframes sg-pulse { 0%, 100% { box-shadow: 0 0 0 4px rgba(5,150,105,0.14); } 50% { box-shadow: 0 0 0 8px rgba(5,150,105,0.06); } }
  @keyframes sg-ring-draw { to { stroke-dashoffset: 72; } }
  @keyframes sg-ring-glow { 0%, 100% { filter: drop-shadow(0 0 0 rgba(124,58,237,0)); } 50% { filter: drop-shadow(0 0 6px rgba(124,58,237,0.35)); } }

  /* ---------- Social proof / logo bar ---------- */
  .sg-page .social-proof { padding: clamp(32px, 7vw, 56px) 24px; background: var(--bg); }
  .sg-page .social-content { max-width: 1280px; margin: 0 auto; text-align: center; }
  .sg-page .social-title { font-family: var(--font-mono); font-size: 12px; letter-spacing: 0.08em; text-transform: uppercase; color: var(--text-tertiary); margin-bottom: 28px; }
  .sg-page .social-logos { display: flex; align-items: center; justify-content: center; gap: clamp(28px, 7vw, 56px); flex-wrap: wrap; }
  .sg-page .social-logo-item { font-family: var(--font-display); font-weight: 600; font-size: 18px; color: var(--text-tertiary); filter: grayscale(1); opacity: 0.6; transition: opacity .2s, filter .2s; }
  .sg-page .social-logo-item:hover { filter: grayscale(0); opacity: 1; color: var(--violet); }

  /* ---------- Courses section ---------- */
  .sg-page .courses-section { padding: clamp(40px, 8vw, 72px) 24px; background: var(--bg-alt); }
  .sg-page .courses-content { max-width: 1280px; margin: 0 auto; }
  .sg-page .courses-title { font-family: var(--font-display); font-size: clamp(24px, 5vw, 34px); font-weight: 700; color: var(--text-primary); text-align: center; margin-bottom: 28px; letter-spacing: -0.01em; }

  .sg-page .tabs { display: flex; justify-content: center; gap: 4px; margin-bottom: 36px; border-bottom: 1px solid var(--border); overflow-x: auto; padding-bottom: 0; -webkit-overflow-scrolling: touch; }
  .sg-page .tab { padding: 12px 18px; font-weight: 600; background: none; border: none; cursor: pointer; font-size: clamp(13px, 2.5vw, 14px); position: relative; white-space: nowrap; flex-shrink: 0; transition: color .15s; }
  .sg-page .tab-inactive { color: var(--text-tertiary); }
  .sg-page .tab-active { color: var(--text-primary); box-shadow: inset 0 -2px 0 var(--violet); }
  .sg-page .tab-inactive:hover { color: var(--text-primary); }

  .sg-page .course-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(min(280px, 100%), 1fr)); gap: 20px; }
  .sg-page .course-card { background: var(--surface); border-radius: 12px; overflow: hidden; box-shadow: var(--shadow-sm); border: 1px solid var(--border); cursor: pointer; transition: box-shadow .2s, transform .2s; width: 100%; }

  .sg-page .course-image { position: relative; height: clamp(140px, 26vw, 172px); background: linear-gradient(135deg, var(--violet-light), var(--violet)); display: flex; align-items: center; justify-content: center; }
  .sg-page .course-badge { position: absolute; top: 12px; left: 12px; padding: 4px 10px; background: rgba(255,255,255,0.92); color: var(--violet); font-size: clamp(10px, 2vw, 11px); font-weight: 700; border-radius: 6px; font-family: var(--font-mono); letter-spacing: 0.02em; }

  .sg-page .course-body { padding: 18px; }
  .sg-page .course-title { font-size: clamp(14px, 2.5vw, 16px); font-weight: 700; color: var(--text-primary); margin-bottom: 10px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  .sg-page .course-meta { display: flex; align-items: center; gap: 8px; font-size: clamp(12px, 2vw, 13px); color: var(--text-secondary); margin-bottom: 12px; flex-wrap: wrap; font-family: var(--font-mono); }
  .sg-page .course-category { padding: 4px 9px; background: var(--surface-2); color: var(--text-secondary); font-size: clamp(10px, 2vw, 11px); font-weight: 600; border-radius: 6px; display: inline-block; }

  /* ---------- Breadcrumb / course detail ---------- */
  .sg-page .breadcrumb { background: var(--surface); border-bottom: 1px solid var(--border); padding: 14px 24px; }
  .sg-page .breadcrumb-content { max-width: 1280px; margin: 0 auto; display: flex; align-items: center; gap: 8px; font-size: clamp(12px, 2.5vw, 13px); color: var(--text-tertiary); flex-wrap: wrap; }
  .sg-page .breadcrumb-link { background: none; border: none; cursor: pointer; color: var(--text-tertiary); font-weight: 500; }
  .sg-page .breadcrumb-link:hover { color: var(--violet); }

  .sg-page .course-page { max-width: 1280px; margin: 0 auto; padding: clamp(28px, 6vw, 56px) 24px; }
  .sg-page .course-layout { display: grid; grid-template-columns: 1fr; gap: 24px; }

  .sg-page .free-badge { display: inline-block; padding: 5px 12px; background: rgba(5,150,105,0.08); color: var(--green); font-size: clamp(12px, 2.5vw, 13px); font-weight: 700; border-radius: 9999px; margin-bottom: 14px; font-family: var(--font-mono); letter-spacing: 0.01em; }
  .sg-page .course-page-title { font-family: var(--font-display); font-size: clamp(26px, 5vw, 38px); font-weight: 700; color: var(--text-primary); margin-bottom: 16px; letter-spacing: -0.01em; }
  .sg-page .course-desc { font-size: clamp(15px, 3vw, 17px); color: var(--text-secondary); margin-bottom: 28px; line-height: 1.7; }

  .sg-page .info-card { background: var(--surface); border-radius: 14px; padding: clamp(22px, 4vw, 32px); box-shadow: var(--shadow-sm); border: 1px solid var(--border); margin-bottom: 24px; }
  .sg-page .info-title { font-family: var(--font-display); font-size: clamp(19px, 4vw, 22px); font-weight: 700; color: var(--text-primary); margin-bottom: 18px; }
  .sg-page .info-list { list-style: none; }
  .sg-page .info-item { display: flex; align-items: flex-start; gap: 12px; color: var(--text-secondary); margin-bottom: 16px; line-height: 1.6; font-size: clamp(14px, 2.5vw, 15px); }
  .sg-page .sg-icon-mark { width: 20px; height: 20px; flex-shrink: 0; margin-top: 1px; border-radius: 6px; background: rgba(124,58,237,0.08); display: flex; align-items: center; justify-content: center; }

  .sg-page .signup-card { background: var(--surface); border-radius: 14px; padding: clamp(22px, 4vw, 32px); box-shadow: var(--shadow-lg); border: 1px solid var(--border); position: static; margin-bottom: 24px; }
  .sg-page .signup-title { font-family: var(--font-display); font-size: clamp(19px, 4vw, 22px); font-weight: 700; color: var(--text-primary); margin-bottom: 8px; text-align: center; }
  .sg-page .signup-subtitle { text-align: center; color: var(--text-tertiary); margin-bottom: 24px; font-size: clamp(13px, 2.5vw, 14px); }

  .sg-page .auth-buttons { display: flex; flex-direction: column; gap: 12px; margin-bottom: 24px; align-items: center; }
  .sg-page .auth-btn { width: 100%; max-width: 330px; display: flex; align-items: center; justify-content: center; gap: 12px; padding: 12px 16px; border: 1px solid var(--border-strong); border-radius: 8px; background: var(--surface); cursor: pointer; font-weight: 600; font-size: clamp(14px, 2.5vw, 15px); transition: background .15s, border-color .15s; }
  .sg-page .auth-btn:hover { background: var(--surface-2); }

  .sg-page .divider { position: relative; margin: 24px 0; }
  .sg-page .divider-line { position: absolute; inset: 0; display: flex; align-items: center; }
  .sg-page .divider-line-inner { width: 100%; border-top: 1px solid var(--border); }
  .sg-page .divider-text { position: relative; display: flex; justify-content: center; font-size: 12px; }
  .sg-page .divider-text span { padding: 0 10px; background: var(--surface); color: var(--text-tertiary); font-family: var(--font-mono); }

  .sg-page .form-group { margin-bottom: 16px; }
  .sg-page .form-label { display: block; font-size: clamp(12px, 2.5vw, 13px); font-weight: 600; color: var(--text-primary); margin-bottom: 8px; }
  .sg-page .form-input { width: 100%; padding: 12px 14px; border: 1px solid var(--border-strong); border-radius: 8px; font-size: clamp(14px, 2.5vw, 15px); background: var(--surface); color: var(--text-primary); }
  .sg-page .form-input:focus { outline: none; border-color: var(--violet); box-shadow: 0 0 0 3px rgba(124,58,237,0.12); }

  .sg-page .privacy { font-size: clamp(11px, 2vw, 12px); color: var(--text-tertiary); text-align: center; margin-top: 16px; line-height: 1.5; }
  .sg-page .privacy a { color: var(--violet); text-decoration: none; }
  .sg-page .privacy a:hover { text-decoration: underline; }

  /* ---------- Dashboard / sidebar ---------- */
  .sg-page .sidebar { width: 256px; background: linear-gradient(180deg, #1c1030, #131318); color: #fff; position: fixed; top: 0; bottom: 0; left: 0; transition: transform 0.3s; z-index: 50; }
  .sg-page .sidebar-hidden { transform: translateX(-100%); }
  .sg-page .sidebar-content { padding: 24px; }
  .sg-page .sidebar-logo { display: flex; align-items: center; gap: 12px; margin-bottom: 48px; }
  .sg-page .sidebar-logo-icon { width: 38px; height: 38px; border-radius: 9px; background: linear-gradient(135deg, var(--violet), var(--blue)); display: flex; align-items: center; justify-content: center; }
  .sg-page .sidebar-logo-text { font-family: var(--font-display); font-size: 18px; font-weight: 700; }

  .sg-page .sidebar-nav { display: flex; flex-direction: column; gap: 6px; }
  .sg-page .sidebar-btn { width: 100%; display: flex; align-items: center; gap: 12px; padding: 11px 14px; background: none; border: none; color: rgba(255,255,255,0.72); cursor: pointer; border-radius: 8px; font-weight: 500; font-size: 14px; transition: background .15s, color .15s; }
  .sg-page .sidebar-btn-active { background: rgba(124,58,237,0.35); color: #fff; }
  .sg-page .sidebar-btn:hover { background: rgba(124,58,237,0.22); color: #fff; }

  .sg-page .sidebar-footer { position: absolute; bottom: 24px; left: 24px; right: 24px; }

  .sg-page .main-content { flex: 1; margin-left: 256px; }
  .sg-page .main-content-full { flex: 1; }

  .sg-page .header { background: var(--surface); border-bottom: 1px solid var(--border); padding: 16px 24px; position: sticky; top: 0; z-index: 40; }
  .sg-page .header-content { display: flex; align-items: center; justify-content: space-between; }
  .sg-page .header-left { display: flex; align-items: center; gap: 16px; }
  .sg-page .menu-btn { padding: 8px; background: none; border: none; cursor: pointer; border-radius: 8px; display: block; color: var(--text-primary); }
  .sg-page .menu-btn:hover { background: var(--surface-2); }
  .sg-page .header-title { font-family: var(--font-display); font-size: clamp(20px, 4vw, 24px); font-weight: 700; color: var(--text-primary); }

  .sg-page .content { padding: clamp(18px, 4vw, 28px); }
  .sg-page .content-header { margin-bottom: 24px; }
  .sg-page .section-title { font-family: var(--font-mono); font-size: clamp(12px, 3vw, 13px); font-weight: 500; letter-spacing: 0.06em; text-transform: uppercase; color: var(--text-secondary); box-shadow: inset 0 -2px 0 var(--violet); display: inline-block; padding-bottom: 10px; }

  .sg-page .home-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(min(280px, 100%), 1fr)); gap: 20px; }
  .sg-page .home-card { background: var(--surface); border-radius: 12px; padding: 20px; box-shadow: var(--shadow-sm); border: 1px solid var(--border); cursor: pointer; transition: box-shadow .2s, transform .2s; }
  .sg-page .home-card:hover { box-shadow: var(--shadow-lg); transform: translateY(-2px); }

  .sg-page .card-header { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 16px; }
  .sg-page .card-icon { width: clamp(44px, 11vw, 56px); height: clamp(44px, 11vw, 56px); background: rgba(124,58,237,0.08); border-radius: 11px; display: flex; align-items: center; justify-content: center; }
  .sg-page .card-progress { font-family: var(--font-mono); font-size: clamp(18px, 4vw, 22px); font-weight: 500; color: var(--violet); }

  .sg-page .card-title { font-size: clamp(14px, 2.5vw, 16px); font-weight: 700; color: var(--text-primary); margin-bottom: 10px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  .sg-page .card-desc { color: var(--text-secondary); font-size: clamp(13px, 2.5vw, 14px); margin-bottom: 16px; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
  .sg-page .card-footer { display: flex; align-items: center; justify-content: space-between; font-size: clamp(12px, 2vw, 13px); color: var(--text-tertiary); flex-wrap: wrap; gap: 8px; font-family: var(--font-mono); }
  .sg-page .card-time { display: flex; align-items: center; gap: 4px; }

  .sg-page .overlay { position: fixed; inset: 0; background: rgba(10,10,20, 0.45); z-index: 40; }

  /* ---------- Responsive ---------- */
  @media (min-width: 768px) {
    .sg-page .hero-grid { grid-template-columns: 1fr 1fr; }
    .sg-page .course-grid { grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); }
    .sg-page .home-grid { grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); }
    .sg-page .signup-card { position: sticky; top: 24px; }
    .sg-page .course-layout { grid-template-columns: 2fr 1fr; }
  }

  @media (min-width: 1024px) {
    .sg-page .sidebar { display: block; }
    .sg-page .main-content { margin-left: 256px; }
    .sg-page .menu-btn { display: none; }
    .sg-page .overlay { display: none; }
  }

  @media (max-width: 767px) {
    .sg-page .sidebar { display: none; }
    .sg-page .sidebar-visible { display: block; }
    .sg-page .main-content { margin-left: 0; }
    .sg-page .tabs { justify-content: flex-start; }
    .sg-page .logo-img { width: 35px; height: 35px; }
    .sg-page .nav-bar { padding: 10px; }
    .sg-page .sg-card-feed { position: static; width: 100%; margin-top: 14px; }
    .sg-page .sg-card-streak { position: static; width: 100%; margin-top: 14px; }
    .sg-page .sg-stack { max-width: 320px; }
  }

  @media (max-width: 480px) {
    .sg-page .hero-content { padding: 28px 16px 24px; }
    .sg-page .courses-section { padding: 28px 16px; }
    .sg-page .course-page { padding: 20px 16px; }
    .sg-page .content { padding: 14px; }
  }

  @media (prefers-reduced-motion: reduce) {
    .sg-page *, .sg-page *::before, .sg-page *::after {
      animation-duration: 0.001ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.001ms !important;
    }
  }
`;

const HomePage = () => {
  const [currentPage, setCurrentPage] = useState('landing');
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('All');

  const [courses, setcourses] = useState([]);
  const [loading,setloading] = useState(true);
  const navigate = useNavigate()



  const { instance } = useMsal()


  const [csrftoken,setcsrftoken] = useState(null)
    async function  fetch_csrf_token(){
      await getCsrfToken();
      setcsrftoken(getCookie('csrftoken'))
    }
  useEffect(() => {

    fetch_csrf_token()
    // eslint-disable-next-line
  }, []);


  useEffect(() => {
        GetallCourses()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

   const GetallCourses = () => {
        senteventdata('GetallCourses API Called React-js','')
        
        custom_api_func.get(`api/get_all_courses_public`)
            .then((response) => {
                //setCourses(response.data.results);
                
                setcourses( response.data.results);                

                setloading(false)
            }).catch((error) => {
                console.log("error", error);
                setloading(false)
            })
    }
  


  const LandingPage = () => (
    <div className="sg-page page">
      <style>{styles}</style>

      <div className="nav-bar">
        <div className="nav-content">
          <div className="nav-left">
            <div className="logo">
               <img
                className="logo-img"
                src={'https://api.successguardian.in/media/logo_sg_small.png'}
                alt="Logo"
              />
              <div className="logo-text">
                <span className="logo-primary">SuccessGuardian</span>
              </div>
              <span className="logo-suffix">Academy</span>
            </div>
            
          </div>
        </div>
      </div>

      <div className="hero">
        <div className="hero-content">
          <div className="hero-grid">
            <div>
              <div className="badges">
                <span className="badge">100% free &amp; online</span>
                <span className="badge">Unlimited access</span>
                
              </div>
              <h1 className="hero-title">
                Grow your career
                <span className="hero-title-line2">in Customer Success</span>
              </h1>
              <p className="hero-text">
                Explore everything from short, actionable courses to complete certifications and build the Customer Success skills that matter most.
              </p>
              <button onClick={() => setCurrentPage('home')} className="btn-primary-lg">
                Sign up for free courses
              </button>
              <div className="hero-trust-row">
                <div className="hero-trust-item"><span className="hero-trust-dot"></span>No credit card required</div>
                <div className="hero-trust-item"><span className="hero-trust-dot"></span>Certificate on completion</div>
                <div className="hero-trust-item"><span className="hero-trust-dot"></span>Learn at your own pace</div>
              </div>
            </div>
            <div>
              <div className="hero-visual">
                <div className="sg-stack">
                  <svg width="0" height="0" style={{position:'absolute'}}>
                    <defs>
                      <linearGradient id="sgRingGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#7c3aed" />
                        <stop offset="100%" stopColor="#2563eb" />
                      </linearGradient>
                    </defs>
                  </svg>

                  <div className="sg-card sg-card-main">
                    <div className="sg-card-header">
                      <span className="sg-card-label">Certification progress</span>
                      <span className="sg-live-dot" aria-hidden="true"></span>
                    </div>
                    <div className="sg-ring-wrap">
                      <svg className="sg-ring" viewBox="0 0 120 120">
                        <circle className="sg-ring-track" cx="60" cy="60" r="52" />
                        <circle className="sg-ring-fill" cx="60" cy="60" r="52" />
                      </svg>
                      <div className="sg-ring-value">
                        <span className="sg-ring-number">78%</span>
                        <span className="sg-ring-caption">Complete</span>
                      </div>
                    </div>
                    <div className="sg-card-footer">Customer Success Fundamentals</div>
                  </div>

                  <div className="sg-card sg-card-feed">
                    <span className="sg-card-label">Recent activity</span>
                    <ul className="sg-feed">
                      <li className="sg-feed-row" style={{animationDelay: '0.15s'}}>
                        <span className="sg-feed-dot sg-dot-green"></span>
                        <span className="sg-feed-name">Onboarding Playbooks</span>
                        <span className="sg-feed-value">100%</span>
                      </li>
                      <li className="sg-feed-row" style={{animationDelay: '0.3s'}}>
                        <span className="sg-feed-dot sg-dot-amber"></span>
                        <span className="sg-feed-name">Renewal Strategy</span>
                        <span className="sg-feed-value">64%</span>
                      </li>
                      <li className="sg-feed-row" style={{animationDelay: '0.45s'}}>
                        <span className="sg-feed-dot sg-dot-green"></span>
                        <span className="sg-feed-name">QBR Essentials</span>
                        <span className="sg-feed-value">100%</span>
                      </li>
                    </ul>
                  </div>

                  <div className="sg-card sg-card-streak">
                    <span className="sg-card-label">Learning streak</span>
                    <span className="sg-streak-number">12 days</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="courses-section">
        <div className="courses-content">
          <h2 className="courses-title">Popular courses</h2>
          
          <div className="tabs">
            {['All', 'Customer Success Courses', 'SuccessGuardian Customer Success Platform Courses'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`tab ${activeTab === tab ? 'tab-active' : 'tab-inactive'}`}
              >
                {tab}
              </button>
            ))}
          </div>
          

         <div
              className="course-grid"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                gap: '24px',
              }}
            >
              {courses
                .filter(course => activeTab === 'All' || course.category === activeTab)
                .slice(0, 8)
                .map((course) => (
                  <div
                    key={course.id}
                    className="course-card"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      overflow: 'hidden',
                      border: '1px solid #ECE7F3',
                      boxShadow: '0 1px 2px rgba(43, 27, 61, 0.06)',
                      transition: 'box-shadow 0.2s ease, transform 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(43, 27, 61, 0.12)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 1px 2px rgba(43, 27, 61, 0.06)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    {/* Image / badge area */}
                    <div
                      className="course-image"
                      style={{
                        position: 'relative',
                        height: '140px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'linear-gradient(135deg, #2B1B3D 0%, #4A2E6B 100%)',
                      }}
                    >
                      {course.badge && (
                        <span
                          className="course-badge"
                          style={{
                            position: 'absolute',
                            top: '12px',
                            left: '12px',
                            padding: '4px 10px',
                            borderRadius: '999px',
                            backgroundColor: 'rgba(255,255,255,0.15)',
                            color: '#fff',
                            fontSize: '12px',
                            fontWeight: 600,
                          }}
                        >
                          {course.badge}
                        </span>
                      )}
                      {(course.thumbnail!=null) ? (
                        <img
                          src={course.thumbnail}
                          alt=""
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      ):(
                        <Award color="white" size={48} style={{ opacity: 0.5 }} />
                      )}
                      
                    </div>

                    {/* Body */}
                    <div
                      className="course-body"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        padding: '20px',
                        flex: 1,
                      }}
                    >
                      

                      <h3
                        className="course-title"
                        style={{
                          margin: 0,
                          fontSize: '18px',
                          fontWeight: 600,
                          color: '#1F1530',
                          lineHeight: 1.3,
                        }}
                      >
                        {course.title}
                      </h3>

                      <p
                        className="card-desc"
                        style={{
                          margin: 0,
                          fontSize: '14px',
                          color: '#6B647A',
                          lineHeight: 1.5,
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                        }}
                      >
                        {course.description}
                      </p>

                      <div
                        className="course-meta"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          fontSize: '13px',
                          color: '#8B849B',
                          marginTop: '4px',
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <Award size={14} color="#7c3aed" />
                          <span>Certification</span>
                        </div>
                        <span style={{ color: '#DDD7E8' }}>|</span>
                        <span>{course.hours}</span>
                      </div>

                      <button
                        onClick={() => {
                          setSelectedCourse(course);
                          setCurrentPage('course');
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#402855'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#7c3aed'; }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px',
                          marginTop: 'auto',
                          padding: '10px 24px',
                          backgroundColor: '#7c3aed',
                          color: '#fff',
                          fontWeight: 500,
                          fontSize: '15px',
                          fontFamily: 'inherit',
                          border: 'none',
                          borderRadius: '9999px',
                          cursor: 'pointer',
                          transition: 'background-color 0.2s ease',
                        }}
                      >
                        <span style={{ fontSize: '11px', lineHeight: 1 }}>▶</span>
                        <span>Access</span>
                      </button>
                    </div>
                  </div>
                ))}
            </div>
                    </div>
                  </div>
                </div>
              );

  const CoursePage = ({ course }) => {

  useEffect(() => {
    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: googleconfig.CLIENT_ID,
        callback: handlegooglesignup,
      });

      window.google.accounts.id.renderButton(
        document.getElementById("googlesignInDiv"),
        {
          theme: "outline",
          size: "large",
          text: "signin_with",
          width: 330,
        }
      );
    }
  }, []);

    const loginwithmicrosoft2 = () =>{
    setloading(true)
    const keys = JSON.parse(sessionStorage.getItem("msal.account.keys"))
    if (keys){
      const emailmicrosoft = JSON.parse(sessionStorage.getItem(keys[0]))["username"]
      if (emailmicrosoft){
      const formData = new FormData();
      formData.append('email', emailmicrosoft);
      

      custom_api_func.post(`api/microsoft-login/`, formData, 
        {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken,},})
        .then((response) => {
          //console.log('response',response)
          setloading(false)
          if (response.data?.msg) {
          
            localStorage.setItem('useremail', response.data.email);
            localStorage.setItem('user_name', response.data.user_name);
            localStorage.setItem('academyid', response.data.academy_id);

            navigate('/acourses/'+response.data.academy_id);

          } else {
            console.log('Error occured y',response)
            toast.error('Error occured',response.data.errors.non_field_errors,
            {style: {
              maxWidth: '500px',
              wordWrap: 'break-word',
              whiteSpace: 'normal',
            },
            duration: 5000,
          })

          }
        })
        .catch((error) => {
          setloading(false)
           if (error?.response?.data?.errors?.non_field_errors) {
            const nonFieldErrors = error.response.data.errors.non_field_errors;
            toast.error(Array.isArray(nonFieldErrors) ? nonFieldErrors.join(", ") : nonFieldErrors);
          } else if (error?.response?.data?.detail) {
            toast.error(error.response.data.detail);
          } else {
            toast.error(`Error occurred: ${getErrorMessage(error)}. Login Failed for this Microsoft id. Please try again`,
           {
          style: {
            maxWidth: '500px',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
          },
          duration: 5000,
        })
          }


        });
      }
    }
    else{
      setloading(false)
      toast.error('Login Failed for this Microsoft id. Please try again')
    }
  }

  const loginwithmicrosoft = () => {
    setloading(true)
      const loginRequest = {
          scopes: ["user.read"], // Add the necessary scopes
      }
      instance.loginPopup(loginRequest)
      .then((response) => {
          console.log('Login successful:', response);
          loginwithmicrosoft2(); 
          
          
      })
      .catch((e) => {
          setloading(false)
          
          toast.error(`Error occurred: ${getErrorMessage(e)}. Login Failed for this Microsoft id. Please try again`,
           {
          style: {
            maxWidth: '500px',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
          },
          duration: 5000,
        })
          console.log('Login failed:', e);
      });
    
}

  const [password, setpassword] = useState("")
  const [username, setUsername] = useState("")

  const normallogin = () =>{
    setloading(true)
    if (username.length>0 && password.length>0 ){
       const formData = new FormData();

      formData.append('username', username);
      formData.append('password', password);

      custom_api_func.post(`api/sglogin/`, formData, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken,}})
        .then((response) => {
          //console.log('response',response)
          setloading(false)
          if (response.data?.msg) {
          
            localStorage.setItem('useremail', response.data.email);
            localStorage.setItem('user_name', response.data.user_name);
            localStorage.setItem('academyid', response.data.academy_id);

            navigate('/acourses/'+response.data.academy_id);

          } else {
            console.log('Error occured y',response)
            toast.error('Error occured',response.data.errors.non_field_errors,
            {style: {
              maxWidth: '500px',
              wordWrap: 'break-word',
              whiteSpace: 'normal',
            },
            duration: 5000,
          })

          }
        })
        .catch((error) => {
          setloading(false)
           if (error?.response?.data?.errors?.non_field_errors) {
            const nonFieldErrors = error.response.data.errors.non_field_errors;
            toast.error(Array.isArray(nonFieldErrors) ? nonFieldErrors.join(", ") : nonFieldErrors);
          } else if (error?.response?.data?.detail) {
            toast.error(error.response.data.detail);
          } else {
            toast.error(`Error occurred: ${getErrorMessage(error)}. Login Failed. Please try again`,
           {
          style: {
            maxWidth: '500px',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
          },
          duration: 5000,
        })
          }


        });
      }
    
    else{
      setloading(false)
      toast.error('Login Failed for this Microsoft id. Please try again')
    }
  }
  

  
    
    return (
    <div className="sg-page page-gray">
      <style>{styles}</style>
      

      <div className="nav-bar">
        <div className="nav-content">
          <div className="nav-left">
            <div className="logo">
              <img
                className="logo-img"
                src={'https://api.successguardian.in/media/logo_sg_small.png'}
                alt="Logo"

              />
              <div className="logo-text">
                <span className="logo-primary">SuccessGuardian</span>
              </div>
              <span className="logo-suffix">Academy</span>
            </div>
          </div>
        </div>
      </div>

      <div className="breadcrumb">
        <div className="breadcrumb-content">
          <button onClick={() => setCurrentPage('landing')} className="breadcrumb-link">Home</button>
          <ChevronRight size={16} />
          <span style={{color: '#131318'}}>{course.title}</span>
        </div>
      </div>

      <div className="course-page">
        <div className="course-layout">
          <div>
            <div style={{marginBottom: '12px'}}>
              <span className="free-badge">FREE Certification Course</span>
            </div>
            
            <h1 className="course-page-title">{course.title}</h1>

            <p className="course-desc">{course.detailedDesc}</p>

            <div className="info-card">
              <h2 className="info-title">Who is this for?</h2>
              <ul className="info-list">
                {course.targetAudience.map((audience, idx) => (
                  <li key={idx} className="info-item">
                    <span className="sg-icon-mark" aria-hidden="true">
                      <svg width="10" height="10" viewBox="0 0 10 10">
                        <path d="M1 5.5L4 8.5L9 1.5" stroke="#7c3aed" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                    <span>{audience}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="info-card">
              <h2 className="info-title">What you'll learn</h2>
              <ul className="info-list">
                {course.sections.map((section_xx, idx) => (
                  <li key={idx} className="info-item">
                    <span 
                    style={{
                      background: 'rgba(9, 250, 65, 0.24)'
                    }}
                    className="sg-icon-mark" aria-hidden="true">
                      <svg width="10" height="10" viewBox="0 0 10 10">
                        <path d="M1 5.5L4 8.5L9 1.5" stroke="#27ec70" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                    <span>{section_xx.title}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div>
            <div className="signup-card">
              <h2 className="signup-title">Sign up to access this course</h2>
              <p className="signup-subtitle">100% free. No credit card needed.</p>

              <div className="auth-buttons">
                <div id="googlesignInDiv"
                style={{
                  width:"300px"
                }}
                ></div>

                <button 
                onClick={()=>{
                    sessionStorage.clear()
                    loginwithmicrosoft()
                  }}
                className="auth-btn">
                  <svg style={{width: '20px', height: '20px'}} viewBox="0 0 24 24">
                    <path fill="#F25022" d="M0 0h11.5v11.5H0z"/>
                    <path fill="#00A4EF" d="M12.5 0H24v11.5H12.5z"/>
                    <path fill="#7FBA00" d="M0 12.5h11.5V24H0z"/>
                    <path fill="#FFB900" d="M12.5 12.5H24V24H12.5z"/>
                  </svg>
                  <span>Sign up with Microsoft</span>
                </button>

              </div>

              <div className="divider">
                <div className="divider-line">
                  <div className="divider-line-inner"></div>
                </div>
                <div className="divider-text">
                  <span>OR</span>
                </div>
                
                
              </div>

              <div>
                <span style={{fontSize:'clamp(11px, 2vw, 12px)', color: '#5c5d70'}}>If you are customer of SuccessGuardian then,</span>
                <div className="form-group" style={{marginTop:"15px"}}>
                  <label className="form-label">SuccessGuardian Email Id *</label>
                  <input type="email" 
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="name@company.com" className="form-input" />
                </div>
                <div className="form-group">
                  <label className="form-label">Password *</label>
                  <input type="password" 
                  value={password}
                  onChange={(e) => setpassword(e.target.value)}
                  placeholder="Enter your password" className="form-input" />
                </div>
                <button onClick={() => normallogin()} className="btn-primary" style={{width: '100%', padding: '12px'}}>
                  Login
                </button>
              </div>

              <p className="privacy">
                We may contact you with relevant content, products, and services. You can unsubscribe at any time.{' '}
                
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  }

  const HomePage = () => (
    <div className="sg-page" style={{display: 'flex', minHeight: '100vh', background: '#f7f7fa'}}>
      <style>{styles}</style>
      
      <div className={`sidebar ${menuOpen ? '' : 'sidebar-hidden'}`}>
        <div className="sidebar-content">
          <div className="sidebar-logo">
            <div className="sidebar-logo-icon">
              <Award color="#ffffff" size={20} />
            </div>
            <span className="sidebar-logo-text">SuccessGuardian</span>
          </div>

          <nav className="sidebar-nav">
            <button className="sidebar-btn sidebar-btn-active">
              <Home size={20} />
              <span>Home</span>
            </button>
            <button className="sidebar-btn">
              <Award size={20} />
              <span>My Certificates</span>
            </button>
          </nav>
        </div>

        <div className="sidebar-footer">
          <button 
          onClick={() => {
           window.location.href = "mailto:successacademy@successguardian.in?subject=Support%20Request";
        }}
          className="sidebar-btn">
            <svg style={{width: '20px', height: '20px'}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Support</span>
          </button>
        </div>
      </div>

      <div className={menuOpen ? 'main-content-full' : 'main-content'}>
        <div className="header">
          <div className="header-content">
            <div className="header-left">
              <button onClick={() => setMenuOpen(!menuOpen)} className="menu-btn">
                {menuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
              <h1 className="header-title">Home</h1>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="content-header">
            <h2 className="section-title">Courses</h2>
          </div>

          <div className="home-grid">
            {courses.map((course) => (
              <div 
                key={course.id} 
                className="home-card"
                onClick={() => {
                  setSelectedCourse(course);
                  setCurrentPage('course');
                }}
              >
                <div className="card-header">
                  <div className="card-icon">
                    <BookOpen color="#7c3aed" size={28} />
                  </div>
                  <span className="card-progress">{course.progress}%</span>
                </div>

                <h3 className="card-title">{course.title}</h3>

                <p className="card-desc">{course.description}</p>

                <div className="card-footer">
                  <div className="card-time">
                    <Clock size={15} />
                    <span>{course?.duration}</span>
                  </div>
                  <span>{course.sections.length}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="overlay" onClick={() => setMenuOpen(false)} />
      )}
    </div>
  );
  
  const getErrorMessage = (error) => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  if (error.message) {
    return error.message;
  }
  return 'An unexpected error occurred';
};


  const handlegooglesignup = (response)  => {
    var usergooglecreds = jwtDecode(response.credential);
    setloading(true)
    if (usergooglecreds.email_verified){
      const formData = new FormData();
      formData.append('email', usergooglecreds.email);
      formData.append('first_name', usergooglecreds.name);

      custom_api_func.post(`api/google-login2/`, formData, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken,},})
      .then((response) => {
        setloading(false)
        if (response.data?.msg) {
          
          localStorage.setItem('useremail', response.data.email);
          localStorage.setItem('user_name', response.data.user_name);
          localStorage.setItem('academyid', response.data.academy_id);

          navigate('/acourses/'+response.data.academy_id);

        } else {
          
          console.log('Error occured y',response)
          toast.error('Error occured',response.data.errors.non_field_errors,
            {style: {
              maxWidth: '500px',
              wordWrap: 'break-word',
              whiteSpace: 'normal',
            },
            duration: 5000,
          })
        }
      })
      .catch((error) => {
        setloading(false)
         if (error?.response?.data?.errors?.non_field_errors) {
          const nonFieldErrors = error.response.data.errors.non_field_errors;
          toast.error(Array.isArray(nonFieldErrors) ? nonFieldErrors.join(", ") : nonFieldErrors);
        } else if (error?.response?.data?.detail) {
          toast.error(error.response.data.detail);
        } else {
          toast.error(`Error occurred: ${getErrorMessage(error)}. Login Failed for this Google id. Please try again`,
        {
        style: {
          maxWidth: '500px',
          wordWrap: 'break-word',
          whiteSpace: 'normal',
        },
        duration: 5000,
      })
        }
      });

    }
    else{
      setloading(false)
      toast.success('Email not verified by google')
    }
    
  };


  return (
    <>
    <Toaster />
    <div>
      {loading ? (
        <LoadingScreen />
      ):(
        <>
      {currentPage === 'landing' ? (
        <LandingPage />
      ) : currentPage === 'home' ? (
        <HomePage />
      ) : (
        <CoursePage course={selectedCourse} />
      )}
      </>
      )}
    </div>
    </>
  );
};

export default HomePage;